import React, { useEffect, useMemo } from 'react';
import { NavBar } from '../kuroco/AppBars';

const RETENTION_DAYS = 30;

export default function AiHistory({
  data,
  onNavigate,
  settingsPath,
  sessionsError,
  onSessionsChanged,
  startNewChat,
  store,
  stylist,
}) {
  useEffect(() => {
    onSessionsChanged?.();
  }, [onSessionsChanged]);

  const groups = useMemo(() => {
    const today = new Date(data.period.today);
    const cutoff = new Date(today.getTime() - RETENTION_DAYS * 86400000);
    const sessions = (data.aiSessions || []).filter((s) => !s.date || new Date(s.date) >= cutoff);
    const out = [];
    sessions.forEach((s) => {
      let g = out.find((x) => x.label === s.group);
      if (!g) {
        g = { label: s.group, items: [] };
        out.push(g);
      }
      g.items.push(s);
    });
    return out;
  }, [data.aiSessions, data.period.today]);

  const empty = groups.length === 0;

  return (
    <div className="ai-screen">
      <NavBar title="会話履歴" backLabel="AI相談" onBack={() => onNavigate('home')} settingsPath={settingsPath} />
      <div className="scroll fade">
        <div className="databanner">
          <span className="dot" />
          <span>
            {stylist
              ? `${stylist}${store ? `（${store}）` : ''} の会話履歴（直近${RETENTION_DAYS}日間）`
              : `過去の会話をセッションごとに確認できます（直近${RETENTION_DAYS}日間）`}
          </span>
        </div>
        {sessionsError && <div className="databanner">{sessionsError}</div>}
        {!store || !stylist ? (
          <div className="databanner">履歴を見るには、ホームで店舗とスタイリストを選択してください。</div>
        ) : null}
        {empty && store && stylist && !sessionsError && (
          <div className="databanner">
            まだ保存された会話がありません。AI相談で話した内容がここに表示されます。
            {startNewChat && (
              <div style={{ marginTop: 10 }}>
                <button
                  type="button"
                  className="chip primary"
                  onClick={() => {
                    startNewChat();
                    onNavigate('home');
                  }}
                >
                  メニューに戻る（振り返り／行動記録／改善）
                </button>
              </div>
            )}
          </div>
        )}
        {groups.map((g) => (
          <div className="sess-group" key={g.label}>
            <div className="sess-group-h">{g.label}</div>
            <div className="sess-list">
              {g.items.map((s) => (
                <button
                  type="button"
                  className="sess-row"
                  key={s.id}
                  onClick={() => onNavigate('aisession', s.id)}
                >
                  <span className="sess-ic">{s.icon}</span>
                  <span className="sess-body">
                    <span className="sess-title">{s.title}</span>
                    <span className="sess-preview">{s.preview}</span>
                  </span>
                  <span className="sess-meta">
                    <span className="sess-time">{s.time}</span>
                    <span className="sess-count">{(s.messages?.length || s.message_count || 0)}件</span>
                    <svg className="sess-chev" viewBox="0 0 8 14" fill="none" aria-hidden="true">
                      <path d="M1 1l6 6-6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </span>
                </button>
              ))}
            </div>
          </div>
        ))}
        <div className="sess-retention">会話履歴は直近{RETENTION_DAYS}日間まで表示されます。</div>
      </div>
    </div>
  );
}
